/*
Template Name: Admin Template
Author: Wrappixel

File: js
*/
// ==============================================================
// Auto select left navbar
// ==============================================================
$(function() {
    "use strict";
    var url = window.location + "";
    url = url.split(/[?#]/)[0];
    var path = url.replace(window.location.protocol + "//" + window.location.host + "/", "");
    path = path.split(/[?#]/)[0];
    if(path.length == 0) path = "home";
    
    var element = $('ul#sidebarnav a').filter(function() {
        //return this.href === url || this.href === path;// || url.href.indexOf(this.href) === 0;
        if(this.dataset.parentFor) {
            let parentFor = JSON.parse(this.dataset.parentFor);
            if(parentFor.some(v => path.includes(v))) return 1;
        }
        return this.href === url || this.href === path;
    });
    element.parentsUntil(".sidebar-nav").each(function (index)
    {
        if($(this).is("li") && $(this).children("a").length !== 0)
        {
            $(this).children("a").addClass("active");
            $(this).parent("ul#sidebarnav").length === 0
                ? $(this).addClass("active")
                : $(this).addClass("selected");
        }
        else if(!$(this).is("ul") && $(this).children("a").length === 0)
        {
            $(this).addClass("selected");

        }
        else if($(this).is("ul")) {
            $(this).addClass('in');
        }
    });

    element.addClass("active");
    $('#sidebarnav a').on('click', function (e) {
        if (!$(this).hasClass("active")) {
            // hide any open menus and remove all other classes
            $("ul", $(this).parents("ul:first")).removeClass("in");
            //$("a", $(this).parents("ul:first")).removeClass("active");

            // open our new menu and add the open class
            $(this).next("ul").addClass("in");
            $(this).attr("aria-expanded", "true");
            $(this).addClass("active");
        } else {
            $(this).removeClass("active");
            $(this).parents("ul:first").removeClass("active");
            $(this).attr("aria-expanded", "false");
            $(this).next("ul").removeClass("in");
        }
    })
    $('#sidebarnav >li >a.has-arrow').on('click', function (e) {
        e.preventDefault();
    });

    // Auto scroll to the active nav
    if ( $(window).width() > 768 || window.Touch) {
        $('.scroll-sidebar').animate({

          //  scrollTop: $("#sidebarnav .sidebar-item.selected").offset().top -250
        }, 500);
    }

});
